/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'bot-class-matcher';
const prefix = `${moduleName}.${componentName}`;

export const classTypesLabel = `${prefix}.classTypesLabel`;
export const selectClientTypePlaceholder = `${prefix}.selectClassTypeLabel`;

export const ENGLISH = {
    [classTypesLabel]: 'Class Types',
    [selectClientTypePlaceholder]: 'Select Class Types',
};
